import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Home.css';
import { userLogin } from '../services/user';
import { getCookie } from '../services/session';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is already logged in
    const isLogged = localStorage.getItem('BMI-admin-is-logged');
    if (isLogged && getCookie()) {
      navigate('/admin');
      return;
    }

    const alertMessage = localStorage.getItem('BMI-admin-message');
    if (alertMessage) {
      setTimeout(() => {
        toast.info(alertMessage);
      }, 100);
      localStorage.removeItem('BMI-admin-message');
    }
  }, [navigate]);

  const handleLogin = async () => {
    if (!email || !password) {
      toast.warn('Please enter both email and password');
      return;
    }

    try {
      const response = await userLogin({ email, password });

      if (response?.BMI_ADMIN) {
        // ✅ Save token to cookie as BMI-admin-session (valid for 1 day)
        const isSecure = window.location.protocol === 'https:';
        document.cookie = `BMI-admin-session=${response.BMI_ADMIN.token}; path=/; max-age=86400; SameSite=Strict${isSecure ? '; secure' : ''}`;
        localStorage.setItem('BMI-admin-is-logged', true);

        toast.success('Login Successful');

        setTimeout(() => {
          navigate('/admin');
        }, 1000);
      } else {
        toast.error(response?.error || 'Invalid email or password');
      }
    } catch (error) {
      toast.error(
        error?.message || 'An error occurred during login. Please try again.'
      );
    }
  };

  return (
    <>
      <div className="login-container min-h-screen flex items-center justify-center bg-[#f9fafb]">
        <div className="login-box w-full max-w-md bg-white rounded-xl shadow-lg p-8 border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
            Admin Login
          </h2>

          <div className="input-group mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              className="login-input w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>

          <div className="input-group mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              className="login-input w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>

          <button
            className="login-button w-full py-2 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 transition"
            onClick={handleLogin}
          >
            Login
          </button>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Login;
